import { initialAction, initialState } from './initial';

type Reducer = (
  state: typeof initialState,
  action: typeof initialAction,
) => typeof initialState;

const reducer: Reducer = (state, action) => {
  const { type, payload } = action ?? {};

  switch (type) {
    case 'UPDATE_WATERMARK_IMAGE':
    case 'UPDATE_WATERMARK_WIDTH':
    case 'UPDATE_WATERMARK_HEIGHT':
    case 'UPDATE_WATERMARK_POSITION':
    case 'UPDATE_WATERMARK_OPACITY': {
      return {
        ...state,
        ...payload,
      };
    }
    default: {
      return state;
    }
  }
};

export { reducer };
